import {connect} from 'react-redux';

import {QuicksurveyStore} from 'client/common/types';

import {getSurveyFilter} from 'client/common/store/selectors/surveys';

import {changeStateFilter} from 'client/common/store/reducers/surveys';

import {DispatchProps, StateProps} from './types';

import Component from './survey-state-filter';

const mapStateToProps = (state: QuicksurveyStore) => {
    return {
        stateFilter: getSurveyFilter(state).state
    };
};

export default connect<StateProps, DispatchProps>(mapStateToProps, {changeStateFilter})(Component);
